import Base from './Base';
import Trigger from '../models/Trigger';

export default class Triggers extends Base {
    get models() {
        const collection = this.data.map((item) => new Trigger(item));
        collection.collection = this;

        return collection;
    }
}